import { create } from 'zustand';
import { useShallow } from 'zustand/shallow';

/* -------------------------------------------------------------------------- */

export enum ModalStatusEnum {
	RedeemPromoModal = 'RedeemPromoModal',
	ForfeitedBonusModal = 'ForfeitedBonusModal',
	SearchModal = 'SearchModal',
	WalletModal = 'WalletModal',
	VerificationLevel1 = 'VerificationLevel1',
	AdditionalVerification = 'AdditionalVerification',
	GeoBlockModal = 'GeoBlockModal',
	DepositLimitKYC2Modal = 'DepositLimitKYC2Modal',
}

interface ModalStore {
	modalStatus: ModalStatusEnum | null;
	actions: {
		setModalStatus: (modalType: ModalStatusEnum | null) => void;
	};
}

const modalStore = create<ModalStore>((set) => ({
	modalStatus: null,

	/* -------------------------------------------------------------------------- */

	actions: {
		setModalStatus: (modalType: ModalStatusEnum | null) => {
			set(() => ({
				modalStatus: modalType,
			}));
		},
	},
}));

export const useModalStatus = () =>
	modalStore(useShallow((state) => state.modalStatus));

export const useModalStoreActions = () => modalStore((state) => state.actions);
